import React from 'react';
import {Link} from 'react-router-dom';

import paths from '@paths';

import {Props} from './types';

import './index.scss';

const FaildCharging: React.FC<Props> = props => {
  return (
    <div className="b__faild-charging">
      <div className="w__title">決済の失敗</div>

      {props.header && (
        <div className="b__note">
          有料プランの決済に失敗しています。
          <Link to={paths.myPage.card}>カード情報の変更</Link>
          を行い、決済をお願い致します。
          <br />
          <b>決済失敗の為無料プランに変更</b>しております。ご了承ください。
        </div>
      )}
      {(props.payment || props.leaving) && (
        <div className="b__note">
          有料プランの決済に失敗している為、
          {props.payment ? 'プラン変更' : '退会'}を行えません。
          <br />
          <Link to={paths.myPage.card}>カード情報の変更</Link>
          を行ってください。
        </div>
      )}
    </div>
  );
};

export default FaildCharging;
